import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import { getLastDocApi,
// getAccPowerTodayApi,
getAccPowerThisMonApi, getCo2ThisYearApi, getReRatioThisMonApi, getEnergyAllInfosApi, getPowerChartApi } from '@/api/energy';
import store from '@/store';
var state = {
  selectedFieldName: '',
  // 判斷顯示哪個案場的每分鐘資料
  energyMinData: [],
  // 每分鐘 meters 內容
  // accPowerTodayData: [], // 各 meter 今日累計用電 (目前沒用到)
  accPowerThisMonData: [],
  // 本月累計用電, 本月用電占比
  accPowerLastMonData: [],
  // 上月累計用電,
  co2ThisYear: '-',
  // 今年累計用電碳排放量
  reRationThisMon: '-',
  lastUpdateTime: '--',
  allFieldInfoData: [],
  chartSummary: {
    timeRange: '',
    total: 0
    // isReset: true
  }
};
var getters = {
  getFieldNameList: function getFieldNameList(state) {
    var _state$allFieldInfoDa;
    return ((_state$allFieldInfoDa = state.allFieldInfoData) === null || _state$allFieldInfoDa === void 0 ? void 0 : _state$allFieldInfoDa.map(function (obj) {
      return obj.fieldName;
    })) || [];
  },
  // 即時用電功率
  getInstantPSum: function getInstantPSum(state) {
    var _state$energyMinData;
    if ((_state$energyMinData = state.energyMinData) !== null && _state$energyMinData !== void 0 && _state$energyMinData.length) {
      var sum = state.energyMinData.reduce(function (accu, curr) {
        return accu + curr.P;
      }, 0);
      return Math.round(sum * 100) / 100;
    }
    return '-';
  },
  // 用電 - 本月累計用電量
  getAccPowerThisMonSum: function getAccPowerThisMonSum(state) {
    var _state$accPowerThisMo;
    if ((_state$accPowerThisMo = state.accPowerThisMonData) !== null && _state$accPowerThisMo !== void 0 && _state$accPowerThisMo.length) {
      var sum = state.accPowerThisMonData.reduce(function (accu, curr) {
        return accu + curr.power;
      }, 0);
      return Math.round(sum * 100) / 100;
    }
    return '-';
  },
  // 用電 - 上月累計用電量
  getAccPowerLastMonSum: function getAccPowerLastMonSum(state) {
    var _state$accPowerLastMo;
    if ((_state$accPowerLastMo = state.accPowerLastMonData) !== null && _state$accPowerLastMo !== void 0 && _state$accPowerLastMo.length) {
      var sum = state.accPowerLastMonData.flatMap(function (day) {
        return day.meters;
      }) // 展平成所有 meter 資料
      .reduce(function (sum, meter) {
        return sum + meter.power;
      }, 0); // 累加 power
      return Math.round(sum * 100) / 100;
    }
    return '-';
  },
  // 用電 - 本月用電占比
  getAccPowerThisMonPercentageData: function getAccPowerThisMonPercentageData(state, getters) {
    var _state$accPowerThisMo2;
    return (_state$accPowerThisMo2 = state.accPowerThisMonData) === null || _state$accPowerThisMo2 === void 0 ? void 0 : _state$accPowerThisMo2.map(function (obj) {
      return {
        name: obj.meterName,
        value: obj.power,
        // tooltip 顯示實際數值用 (預設是 %)
        y: Math.round(obj.power / getters.getAccPowerThisMonSum * 1000) / 10
      };
    });
  }
};
var mutations = {
  // SET_CHART_SUMMARY_IS_RESET (state, payload) {
  //   state.chartSummary.isReset = payload
  // },
  SET_CHART_SUMMARY: function SET_CHART_SUMMARY(state, payload) {
    state.chartSummary = payload;
  },
  SET_ENERGY_ALL_FIELD_INFO_DATA: function SET_ENERGY_ALL_FIELD_INFO_DATA(state, payload) {
    // state.allFieldInfoData = payload.sort((a, b) => a.queue - b.queue)
    // 先把禾豐放最後一個
    state.allFieldInfoData = payload.sort(function (a, b) {
      if (a.queue === 1) return 1;
      if (b.queue === 1) return -1;
      // if (a.queue === 1 && b.queue !== 1) return 1;
      // if (a.queue !== 1 && b.queue === 1) return -1;
      return a.queue - b.queue;
    });

    // 群組管理尚未提供設定, 先在這裡設定權限
    // Pendy 僅能看辦公室相關案場
    if (store.state.userDetail.displayName === '總務-Pendy') {
      var list = ['桃園辦公室用電', '台北辦公室用電', '台中辦公室用電', '高雄辦公室用電'];
      state.allFieldInfoData = state.allFieldInfoData.filter(function (item) {
        return list.includes(item.fieldName);
      });
    }
  },
  // 切換分頁 取 fileName call api
  SET_SELECTED_FIELD_NAME: function SET_SELECTED_FIELD_NAME(state, payload) {
    state.selectedFieldName = payload;
  },
  SET_LAST_UPDATE_TIME: function SET_LAST_UPDATE_TIME(state, payload) {
    state.lastUpdateTime = payload !== null && payload !== void 0 && payload.timestamp ? dayjs(payload.timestamp).format('YYYY-MM-DD HH:mm:ss') : '--';
  },
  // 各 meter 資訊
  SET_ENERGY_MIN_DATA: function SET_ENERGY_MIN_DATA(state, payload) {
    var _payload$meters;
    state.energyMinData = (_payload$meters = payload === null || payload === void 0 ? void 0 : payload.meters) !== null && _payload$meters !== void 0 ? _payload$meters : [];
  },
  // 各 meter 今日用電 (目前沒用到)
  // SET_ACC_POWER_TODAY_DATA (state, payload) {
  //   state.accPowerTodayData = payload?.map((obj) => ({
  //     ...obj,
  //     powerGenToday: Math.round(obj.powerGenToday * 100) / 100
  //   }))
  // },
  // 本月累計用電, 本月用電占比
  SET_ACC_POWER_THIS_MON_DATA: function SET_ACC_POWER_THIS_MON_DATA(state, payload) {
    var _payload$map;
    state.accPowerThisMonData = (_payload$map = payload === null || payload === void 0 ? void 0 : payload.map(function (obj) {
      return _objectSpread(_objectSpread({}, obj), {}, {
        power: Math.round(obj.power * 100) / 100
      });
    })) !== null && _payload$map !== void 0 ? _payload$map : [];
  },
  // 上月累計用電
  SET_ACC_POWER_LAST_MON_DATA: function SET_ACC_POWER_LAST_MON_DATA(state, payload) {
    state.accPowerLastMonData = payload;
  },
  SET_CO2_THIS_YEAR: function SET_CO2_THIS_YEAR(state, payload) {
    state.co2ThisYear = payload ? Math.round(payload * 100) / 100 : '-';
  },
  SET_RE_RATION_THIS_MON: function SET_RE_RATION_THIS_MON(state, payload) {
    state.reRationThisMon = payload !== null && payload !== void 0 ? payload : '-';
  }
};
var actions = {
  // 接收 websocket 傳的 各 meter 資訊
  setEnergyMinData: function setEnergyMinData(_ref, data) {
    var state = _ref.state,
      commit = _ref.commit;
    if (data.field_name === state.selectedFieldName) {
      commit('SET_ENERGY_MIN_DATA', data);
      commit('SET_LAST_UPDATE_TIME', data);
    }
  },
  getEnergyAllFieldInfoData: function getEnergyAllFieldInfoData(_ref2) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var commit, _res$data$data, _res$data$data$, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref2.commit;
              _context.prev = 1;
              _context.next = 4;
              return getEnergyAllInfosApi();
            case 4:
              res = _context.sent;
              commit('SET_ENERGY_ALL_FIELD_INFO_DATA', res.data.data);
              commit('SET_SELECTED_FIELD_NAME', (_res$data$data = res.data.data) === null || _res$data$data === void 0 ? void 0 : (_res$data$data$ = _res$data$data[0]) === null || _res$data$data$ === void 0 ? void 0 : _res$data$data$.fieldName);
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              console.log('getEnergyAllFieldInfoData', _context.t0);
            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }))();
  },
  // api 各 meter 最新一筆資訊
  getLastDocData: function getLastDocData(_ref3, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var commit, _res$data$data2, _res$data$data3, res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit;
              _context2.prev = 1;
              _context2.next = 4;
              return getLastDocApi(payload);
            case 4:
              res = _context2.sent;
              commit('SET_ENERGY_MIN_DATA', (_res$data$data2 = res.data.data) === null || _res$data$data2 === void 0 ? void 0 : _res$data$data2[0]);
              commit('SET_LAST_UPDATE_TIME', (_res$data$data3 = res.data.data) === null || _res$data$data3 === void 0 ? void 0 : _res$data$data3[0]);
              _context2.next = 12;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](1);
              console.log('getLastDocData', _context2.t0);
            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 9]]);
    }))();
  },
  // 目前沒用到
  // async getAccPowerTodayData ({ commit }, payload) {
  //   try {
  //     const res = await getAccPowerTodayApi(payload)
  //     commit('SET_ACC_POWER_TODAY_DATA', res.data.data)
  //   } catch (error) {
  //     console.log('getAccPowerTodayData', error)
  //   }
  // },
  getAccPowerThisMonData: function getAccPowerThisMonData(_ref4, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var commit, res;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref4.commit;
              _context3.prev = 1;
              _context3.next = 4;
              return getAccPowerThisMonApi(payload);
            case 4:
              res = _context3.sent;
              commit('SET_ACC_POWER_THIS_MON_DATA', res.data.data);
              _context3.next = 11;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              console.log('getAccPowerThisMonData', _context3.t0);
            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 8]]);
    }))();
  },
  getAccPowerLastMonData: function getAccPowerLastMonData(_ref5, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var commit, lastMonth, params, res;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref5.commit;
              lastMonth = dayjs().subtract(1, 'month').format('YYYY-MM');
              params = {
                fieldName: payload,
                startDate: lastMonth,
                endDate: lastMonth
              };
              _context4.prev = 3;
              _context4.next = 6;
              return getPowerChartApi(params);
            case 6:
              res = _context4.sent;
              commit('SET_ACC_POWER_LAST_MON_DATA', res.data.data);
              _context4.next = 13;
              break;
            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](3);
              console.log('getAccPowerLastMonData', _context4.t0);
            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 10]]);
    }))();
  },
  getCo2ThisYear: function getCo2ThisYear(_ref6, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var commit, res;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref6.commit;
              _context5.prev = 1;
              _context5.next = 4;
              return getCo2ThisYearApi(payload);
            case 4:
              res = _context5.sent;
              commit('SET_CO2_THIS_YEAR', res.data.data);
              _context5.next = 11;
              break;
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);
              console.log('getCo2ThisYear', _context5.t0);
            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 8]]);
    }))();
  },
  getReRatioThisMon: function getReRatioThisMon(_ref7, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var commit, res;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref7.commit;
              _context6.prev = 1;
              _context6.next = 4;
              return getReRatioThisMonApi(payload);
            case 4:
              res = _context6.sent;
              commit('SET_RE_RATION_THIS_MON', res.data.data);
              _context6.next = 11;
              break;
            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](1);
              console.log('getReRatioThisMon', _context6.t0);
            case 11:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1, 8]]);
    }))();
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};